"use client";

import { useReportWebVitals } from "next/web-vitals";

export default function WebVitals() {
    useReportWebVitals((metric) => {
        const enabled = process.env.NEXT_PUBLIC_ENABLE_WEB_VITALS === "true" || process.env.NODE_ENV === "development";
        if (!enabled) return;

        const { name, value, rating, id, navigationType } = metric;
        
        const theme = {
            good: { color: "#10b981", emoji: "🟢" },
            "needs-improvement": { color: "#f59e0b", emoji: "🟡" },
            poor: { color: "#ef4444", emoji: "🔴" }
        }[rating as "good" | "needs-improvement" | "poor" || "good"];

        // Format values nicely
        const displayValue = name === "CLS" 
            ? value.toFixed(4) 
            : `${Math.round(value)}ms`;

        // Diagnostic breakdown tips for LCP and other metrics
        const tips: Record<string, string> = {
            TTFB: "Time to First Byte. Server response speed. Target: < 800ms.",
            FCP: "First Contentful Paint. Time to display first visual element. Target: < 1.8s.",
            LCP: "Largest Contentful Paint. Main content loading speed. Target: < 2.5s.",
            CLS: "Cumulative Layout Shift. Visual stability. Target: < 0.1.",
            FID: "First Input Delay. Page interactivity. Target: < 100ms.",
            INP: "Interaction to Next Paint. Tap/Click responsiveness. Target: < 200ms."
        };

        console.groupCollapsed(
            `%c${theme.emoji} Web Vitals: ${name} = ${displayValue} (${rating?.toUpperCase()})`,
            `color: ${theme.color}; font-weight: bold; font-family: monospace;`
        );
        console.log(`%cMetric Name: %c${name}`, "font-weight: bold;", "font-family: monospace;");
        console.log(`%cValue: %c${displayValue}`, "font-weight: bold;", "font-family: monospace;");
        console.log(`%cRating: %c${rating}`, "font-weight: bold;", `color: ${theme.color}; font-weight: bold;`);
        console.log(`%cNavigation Type: %c${navigationType}`, "font-weight: bold;", "font-style: italic;");
        console.log(`%cMetric ID: %c${id}`, "font-weight: bold; color: #6b7280;", "font-family: monospace; color: #6b7280;");
        console.log(`%cDiagnostic Tip: %c${tips[name] || ""}`, "font-weight: bold; color: #4b5563;", "color: #4b5563;");
        console.groupEnd();
    });

    return null;
}
